import React from 'react'
import debounce from 'lodash/debounce'
import { useRouter } from 'next/router'

import { useFeatureFlagContext } from './useFeatureFlagContext'
import { useLocalStorage } from '../useLocalStorage'
import { usePelatihanMandiriDesktopView } from 'app/PelatihanMandiriPage/hooks/usePelatihanMandiriDesktopView'

const PELATIHAN_MANDIRI_DESKTOP_PATHS = [
  '/pelatihan-mandiri',
  '/pelatihan-mandiri/daftar-topik',
  '/pelatihan-mandiri/daftar-aksi-nyata',
]

export const useScreenSizeHook = () => {
  const { pathname } = useRouter()
  const { status } = useFeatureFlagContext()
  const isEnableDesktopLayout = usePelatihanMandiriDesktopView()
  const isDesktopPathAllowed =
    PELATIHAN_MANDIRI_DESKTOP_PATHS.includes(pathname)
  const shouldEnableDesktopLayout =
    isEnableDesktopLayout && isDesktopPathAllowed
  const [isDesktop, setIsDesktop] = React.useState<boolean>(false)
  const [, setDesktopScreenSizeFlag] = useLocalStorage(
    'isDesktopScreenSize',
    false
  )

  const handleWindowSizeChange = debounce(() => {
    const isWindowDesktopWidth =
      window?.innerWidth >= 768 && shouldEnableDesktopLayout

    setDesktopScreenSizeFlag(isWindowDesktopWidth)
    setIsDesktop(isWindowDesktopWidth)
  }, 500)

  React.useEffect(() => {
    if (status === 'success') {
      if (shouldEnableDesktopLayout) {
        const isWindowDesktopWidth = window?.innerWidth >= 768
        setDesktopScreenSizeFlag(isWindowDesktopWidth)
        setIsDesktop(isWindowDesktopWidth)
      } else {
        setDesktopScreenSizeFlag(false)
        setIsDesktop(false)
      }
    }

    if (shouldEnableDesktopLayout) {
      window.addEventListener('resize', handleWindowSizeChange)
      return () => {
        window.removeEventListener('resize', handleWindowSizeChange)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, shouldEnableDesktopLayout])

  return {
    isDesktop,
    status,
    toggleDesktop: shouldEnableDesktopLayout,
  }
}
